import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../stores/authenticationStore'

export const TimekeepingSyncRequest = {
  exportToExcel: ({ keyword, deId, fromDate, toDate }) => {
    return axios({
      method: 'GET',
      url: `${apiUrl}/api/v1/timekeepingSync/export`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params: {
        keyword,
        deId,
        fromDate,
        toDate,
      },
      responseType: 'blob',
    })
  },
}
